module.exports = __webpack_public_path__ + "img/add_user.ae65c687.svg";